import { render } from "./ProgramDescription.vue?vue&type=template&id=6991e0af"
import script from "./ProgramDescription.vue?vue&type=script&lang=js"
export * from "./ProgramDescription.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__